import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { isEmpty } from 'lodash';
import PulseLoader from 'react-spinners/PulseLoader';
import { usePrevious } from '../../hooks/userPrevious';
import firebase from '../../config/firebase.config';
import { leaveActionTypes } from '@store/Leave/Leave.actionTypes';
import { teamActionTypes } from '@store/Team/Team.actionTypes';
import { getTeamMemberDetails } from '../../services/teamMemberDetails';
import { columnsConfig } from './LeaveRequest.config';
import { Table } from '@/components/Table';
import styles from './LeaveRequest.module.scss';
import { LeaveRequestModal } from './LeaveRequestModal.component';
import { Modal as CustomModal } from '@/components/Modal';
const database = firebase.firestore();

export const LeaveRequestComponent = () => {
  const teams = useSelector((state) => ({
    projects: state.team.projects,
    active: state.team.active,
    teams: state?.team?.teams,
  }));
  const leaveState = useSelector((state) => state.leave || {});
  const { managerRequests, loading, approveLoading, rejectLoading } =
    leaveState;
  const { activeCompany } = useSelector((state) => state.auth.profile);
  const { profile } = useSelector((state) => state.auth);
  const dispatch = useDispatch();

  const [processModal, setProcessModal] = useState(false);
  const [selectedData, setSelectedData] = useState(null);
  const [companyMemberDetails, setCompanyMemberDetails] = useState({});

  // Load member details for all teams in company (requests can reference any team's members)
  useEffect(() => {
    if (!activeCompany?.companyId) return;
    database
      .collection('teamDatabase')
      .where('ownedBy', '==', activeCompany.companyId)
      .get()
      .then(async (snap) => {
        const teamIds = snap.docs.map((d) => d.id);
        const merged = {};
        await Promise.all(
          teamIds.map(async (teamId) => {
            const details = await getTeamMemberDetails(database, teamId);
            if (details && typeof details === 'object') {
              Object.assign(merged, details);
            }
          })
        );
        setCompanyMemberDetails(merged);
      })
      .catch(() => setCompanyMemberDetails({}));
  }, [activeCompany?.companyId]);

  const getRegData = () => {
    if (!activeCompany?.companyId) return;
    dispatch({
      type: leaveActionTypes.GET_MANAGER_REQUESTS,
      payload: {
        managerId: profile.id,
        companyId: activeCompany.companyId,
      },
    });
  };

  const openProcessModal = (rowData) => {
    if (rowData?.status === 'Pending') {
      setSelectedData(rowData);
      setProcessModal(true);
    }
  };

  const closeProcessModal = () => {
    if (!approveLoading && !rejectLoading) {
      setProcessModal(false);
      setSelectedData(null);
    }
  };

  const handleApprove = () => {
    if (!selectedData || !activeCompany?.companyId) return;
    dispatch({
      type: leaveActionTypes.APPROVE_REQUEST,
      payload: {
        companyId: activeCompany.companyId,
        requestId: selectedData.id,
        requestData: {
          ...selectedData,
          assignee: selectedData.assignee || profile.id,
        },
      },
    });
  };

  const handleReject = () => {
    if (!selectedData || !activeCompany?.companyId) return;
    dispatch({
      type: leaveActionTypes.REJECT_REQUEST,
      payload: {
        companyId: activeCompany.companyId,
        requestId: selectedData.id,
        assigneeId: profile.id,
      },
    });
  };

  // Close process modal when approve/reject saga completes
  const prevApproveLoading = usePrevious(approveLoading);
  const prevRejectLoading = usePrevious(rejectLoading);
  useEffect(() => {
    const approveJustFinished =
      prevApproveLoading === true && approveLoading === false;
    const rejectJustFinished =
      prevRejectLoading === true && rejectLoading === false;
    if (processModal && (approveJustFinished || rejectJustFinished)) {
      setProcessModal(false);
      setSelectedData(null);
    }
  }, [
    approveLoading,
    rejectLoading,
    processModal,
    prevApproveLoading,
    prevRejectLoading,
  ]);

  const ReporterTemplete = (rowData) => {
    const m = companyMemberDetails[rowData?.userId];
    return m?.userName || m?.userEmailid || rowData?.userId || '';
  };

  const ReportDateTempelate = (rowData) => {
    const dateObject = rowData?.requestDate?.toDate?.();
    if (!dateObject) return '';
    let day = dateObject.getDate();
    let month = dateObject.getMonth() + 1;
    const year = dateObject.getFullYear();
    day = day < 10 ? '0' + day : day;
    month = month < 10 ? '0' + month : month;
    return `${day}-${month}-${year}`;
  };

  const TaskDateTempelate = (rowData) => {
    const dateStringtemp = rowData?.leaveDate;
    if (!dateStringtemp) return '';
    const parts = dateStringtemp.split('-');
    const yeartemp = parseInt(parts[0], 10);
    const monthtemp = parseInt(parts[1], 10) - 1;
    const daytemp = parseInt(parts[2], 10);
    const dateObject = new Date(yeartemp, monthtemp, daytemp);
    let day = dateObject.getDate();
    let month = dateObject.getMonth() + 1;
    const year = dateObject.getFullYear();
    day = day < 10 ? '0' + day : day;
    month = month < 10 ? '0' + month : month;
    return `${day}-${month}-${year}`;
  };

  useEffect(() => {
    if (!isEmpty(teams.active)) {
      dispatch({
        type: teamActionTypes.GET_PROJECT,
        payload: { companyId: activeCompany.companyId },
      });
    }
    if (activeCompany?.companyId) {
      getRegData();
    }
  }, [activeCompany?.companyId]);

  return (
    <>
      <div className={styles.leaveRequestPage}>
        {loading ? (
          <div className="w-100 d-flex justify-content-center">
            <PulseLoader color="#4f58bb" />
          </div>
        ) : (
          <Table
            className={styles.leaveRequestTableContainer}
            data={managerRequests || []}
            columns={columnsConfig({
              companyMemberDetails,
              openProcessModal,
              approveLoading,
              rejectLoading,
            })}
          />
        )}
      </div>
      <CustomModal isVisible={processModal} onClose={closeProcessModal}>
        <LeaveRequestModal
          onAccept={handleApprove}
          onDecline={handleReject}
          selectedData={selectedData}
          ReporterTemplete={ReporterTemplete}
          ReportDateTempelate={ReportDateTempelate}
          TaskDateTempelate={TaskDateTempelate}
          onClose={closeProcessModal}
          approveLoading={approveLoading}
          rejectLoading={rejectLoading}
        />
      </CustomModal>
    </>
  );
};
